import React, { useState , Fragment} from "react";
import PropTypes from "prop-types";
import Accordion from "react-bootstrap/Accordion";
import { Row, Col, Modal, Button } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import Image from "react-bootstrap/Image";
import {
  SwipeableList,
  SwipeableListItem,
} from "@sandstreamdev/react-swipeable-list";
import "@sandstreamdev/react-swipeable-list/dist/styles.css";
import SlidingComponent from "../../reusableComponents/slidingToggleComponent/SlidingComponent";
import { NavLink } from "react-router-dom";
import SVG from "react-inlinesvg";
import SimpleReactLightbox, { SRLWrapper } from "simple-react-lightbox";

const MobileStaffManagement = (props) => {
  console.log(props.data.active)
  //state
  const [show, setShow] = useState(false);
  return (
    
    <React.Fragment>
      <SwipeableList className={`swipe`}>
        {({ swipe, ...rest }) => (
          <div className={`${show ? "swipe" : ""}`}>
            <SwipeableListItem
              swipeLeft={{
                content: (
                  <div>
                    <div className="sectiontwo d-flex swipeOption">
                      <ViewModal
                        data={props.data}
                        mobileView
                      />
                      <NavLink to="/editstaff">
                        <button
                          type="button"
                          className="n_button_d_status font_18_m "
                          style={{ backgroundColor: "#37AC1E", color: "white" }}
                          
                        >
                          Edit
                        </button>
                      </NavLink>
                      
                      <DeleteModal mobileView />
                     

                      <FlagModal
                        data={props.data}
                        mobileView
                      />
                      <BlockModal
                        data={props.data}
                        mobileView
                      />
                     
                    </div>
                  </div>
                ),
                action: () => setShow(true),
              }}
              swipeRight={{
                // content: <div>Revealed content during swipe</div>,
                action: () => setShow(false),
              }}
              {...rest}
            >
              <Card className="main-reusable-accordion">
                <Accordion.Toggle
                  as={Card.Header}
                  eventKey={props.indexKey + 1}
                  eventKey={1}
                >
                  <div className="d-flex align-items-center">
                    <div className="card-header-left" style={{ width: "25%" }}>
                      <div className=" align-items-start">
                        <div className="f9-500">{props.data.name}</div>
                      </div>
                    </div>
                    <div
                      className="card-header-middle f10-500"
                      style={{ width: "33.3333%" }}
                    >
                      <div className="section-one-box">
                        <div className="f9-500">
                          {props.data.email}
                          <br />
                          {props.data.mobile_number}
                        </div>
                      </div>
                    </div>
                    <div
                      className={"card-header-middle"}
                      style={{ width: "25%", textAlign: "center" }}
                    >
                      <div
                        className="d-flex align-items-center"
                        style={{ paddingLeft: "30px" }}
                      >
                        <div className="f9-500">{props.data.role}</div>
                      </div>
                    </div>
                    <div
                      className={"card-header-right ml-3 justify-content-end"}
                      style={{ width: "16.666%" }}
                    >
                      <div className="f9-500">
                        <div>
                          <SlidingComponent
                            name="status"
                            checked={props.data.active}
                            currentState={props.data.active}
                            type={"checkbox"}
                            toggleclass={
                              "toggle vendor-super-admin-toggle d-flex align-items-center mb-2"
                            }
                            toggleinputclass={
                              "toggle__switch vendor-super-admin-toggle"
                            }
                            onChange={() => {
                              //   changeStatus(data._id, !data.active);
                            }}
                            // slidingonClick={this.onSelecttogglestatusChange(data)}
                            // defaultChecked={true}
                          />
                          <div className="f10-500 mr-3">
                            {props.data.active ? "Active" : "Inactive"}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Accordion.Toggle>
                <Accordion.Collapse eventKey={props.indexKey + 1} eventKey={1}>
                  <Card.Body>
                    {/******* Section One *********/}
                    <hr className="mt-0" />
                    <div className="row">
                      <div className="col-3  sectionone-left">
                        <p className="f9-400 pb-2 opacity5">Availability</p>
                        <SlidingComponent
                          name="status"
                          checked={props.data.active}
                          currentState={props.data.active}
                          type={"checkbox"}
                          toggleclass={
                            "toggle vendor-super-admin-toggle d-flex align-items-center mb-2"
                          }
                          toggleinputclass={
                            "toggle__switch vendor-super-admin-toggle"
                          }
                          onChange={() => {
                            //   changeStatus(data._id, !data.active);
                          }}
                          // slidingonClick={this.onSelecttogglestatusChange(data)}
                          // defaultChecked={true}
                        />
                        <div className="f10-500 mr-3 align-items-center">
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          {props.data.active ? "Yes" : "No"}
                        </div>
                      </div>
                      <div
                        className="col-9 sectionone-middle border-right border-left"
                        style={{ marginBottom: "10px" }}
                      >
                        <div className="d-flex">
                          <ViewModal data={props.data} />
                          <NavLink to="/editstaff">
                            <div className="enIconBtn mr-1">
                              <Image
                                src={require("../../../assets/images/UserManagement/pencil.svg")}
                                alt="Edit"
                                title="Edit"
                                fluid
                              />
                            </div>
                          </NavLink>
                          <DeleteModal
                            redButton={true}
                            name="Role"
                            // onClick={(handleCloseBlockUser) =>
                            //   deleteRole(
                            //     data._id,
                            //     handleCloseBlockUser
                            //   )
                            // }
                          />
                          <FlagModal redButton={true} />
                          <BlockModal redButton={true} />
                        </div>
                      </div>
                    </div>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            </SwipeableListItem>
          </div>
        )}
      </SwipeableList>
    </React.Fragment>
  );
};

const BlockModal = (props) => {
  const [showBlockUser, seShowBlockUser] = useState(false);
  const handleCloseBlockUser = () => seShowBlockUser(false);
  const handleShowBlockUser = () => seShowBlockUser(true);
  return (
    <React.Fragment>
      { props.mobileView ? (
          <button
          type="button"
          className="n_button_d_status font_18_m "
          style={{ backgroundColor: "#FCB614", color: "white" }}
          onClick={handleShowBlockUser}
        >
          View
        </button>
      ):(
      <Fragment>
      {props.redButton ? (
        <div className="enIconBtn mr-1" onClick={handleShowBlockUser}>
          <Image
            src={require("../../../assets/images/iconButton/lock.png")}
            alt="Delete"
            title="Delete"
            fluid
          />
        </div>
      ) : (
        <button
          type="button"
          className="enBtnoutlineGrayIcon"
          onClick={handleShowBlockUser}
        >
          <SVG src={require("../../../assets/images/iconButton/lock.png")} />
        </button>
      )}
      </Fragment>
      )}
      <Modal show={showBlockUser} onHide={handleCloseBlockUser} centered>
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <Modal.Title>Block Staff</Modal.Title>
        </Modal.Header>
        <Modal.Body className="f16-500">
          Are you sure to Block the staff?
        </Modal.Body>
        <Modal.Footer className="justify-content-start border-0">
          <Button
            variant="outline-secondary"
            className="btn-lg mr-4 px-5"
            onClick={handleCloseBlockUser}
          >
            No
          </Button>
          <Button
            variant="danger"
            className="btn-lg px-5"
            onClick={() => {
              handleCloseBlockUser();
              //   props.onClick(handleCloseBlockUser);
            }}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

const DeleteModal = (props) => {
  const [showBlockUser, seShowBlockUser] = useState(false);
  const handleCloseBlockUser = () => seShowBlockUser(false);
  const handleShowBlockUser = () => seShowBlockUser(true);
  return (
    <React.Fragment>
      {props.mobileView ? (
         <button
         type="button"
         className="n_button_d_status font_18_m popup-cancel-button"
         style={{ backgroundColor: "#EE3A23", color: "white" }}
         onClick={handleShowBlockUser}
       >
         <div>
           <i
             style={{ color: "#ffffff" }}
             class="fa fa-trash"
             aria-hidden="true"
           ></i>
           <br />
           Delete
         </div>
       </button>
      ):(
        <Fragment>
          {props.redButton ? (
            <div className="enIconBtn mr-1" onClick={handleShowBlockUser}>
              <Image
                src={require("../../../assets/images/UserManagement/Delete.svg")}
                alt="Delete"
                title="Delete"
                fluid
              />
            </div>
          ) : (
            <button
              type="button"
              className="enBtnoutlineGrayIcon"
              onClick={handleShowBlockUser}
            >
              <SVG
                src={require("../../../assets/images/UserManagement/Delete.svg")}
              />
            </button>
          )}
        </Fragment>
         
      )}
      <Modal show={showBlockUser} onHide={handleCloseBlockUser} centered>
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body className="f16-500">
          Are you sure to Delete the {props.name} ?
        </Modal.Body>
        <Modal.Footer className="justify-content-start border-0">
          <Button
            variant="outline-secondary"
            className="btn-lg mr-4 px-5"
            onClick={handleCloseBlockUser}
          >
            No
          </Button>
          <Button
            variant="danger"
            className="btn-lg px-5"
            onClick={() => {
              handleCloseBlockUser();
              //   props.onClick(handleCloseBlockUser);
            }}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

const ViewModal = (props) => {
  const [ShowViewRole, setShowViewRole] = useState(false);
  const handleShowViewRole = () => setShowViewRole(!ShowViewRole);

  return (
    <>
    {props.mobileView ?(
      <button
      type="button"
      className="n_button_d_status font_18_m "
      style={{ backgroundColor: "#2196F3", color: "white" }}
      onClick={handleShowViewRole}
    >
      View
    </button>
    ):(
      <div className="enIconBtn mr-1" onClick={handleShowViewRole}>
        <Image
          src={require("../../../assets/images/UserManagement/eye.svg")}
          alt="Edit"
          title="Edit"
          fluid
        />
      </div>
    )}
      <Modal show={ShowViewRole} onHide={handleShowViewRole} centered size="lg">
        <Modal.Header className="px-4 border-0" closeButton>
          <div>
            <Modal.Title className="f20-700 pb-2">
              View Staff Details
            </Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body className="px-4">
          <div className="row">
            <div className="col-4 f14-700 ">Status </div>
            <div className="col-4 f14-400 ">
              {props.data.active ? "Active" : "Inactive"}{" "}
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-4 f14-700 ">Availability </div>
            <div className="col-4 f14-400 ">
              {props.data.active ? "Yes" : "No"}{" "}
            </div>
          </div>
          <hr />
          <div className="row mt-2">
            <div className="col-6 f14-700 ">Role Name </div>
            <div className="col-6 f14-400 ">
              Role Name
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-6 f14-700 ">Select Role</div>
            <div className="col-6 f14-400 ">
            Select Role
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-6 f14-700 ">Location ID</div>
            <div className="col-6 f14-400 ">
            Street Meat, Lane Number 6, Ganga Fortune Society, Meera Nagar, ….
            </div>
          </div>
         
          <div className="row mt-2">
            <div className="col-6 f14-400 ">
              Drop a pin to your address Move the marker as required
            </div>
            <div className="col-6 f14-400 ">Auto Detect Location</div>
          </div>
          {/* <div className="row mt-2">Location</div> */}
          <br />
          <hr />
          <div className="row mt-2">
            <div className="col-6 f14-700 ">First Name</div>
            <div className="col-6 f14-400 ">
            Alex
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-6 f14-700 ">Last Name</div>
            <div className="col-6 f14-400 ">
            Peter
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-6 f14-700 ">Email Address</div>
            <div className="col-6 f14-400 ">
            sophiaj@email.com
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-6 f14-700 ">Password</div>
            <div className="col-6 f14-400 ">
            ***********
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-6 f14-700 ">Phone Number</div>
            <div className="col-6 f14-400 ">
            +91 9876543210
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-6 f14-700 ">Add Profile Photo</div>
            <div className="col-6 f14-400 ">
            Peter
            </div>
          </div>
          <hr />
          <div className="row mt-2">
            <div className="col-6 f14-700 ">Address Line 1</div>
            <div className="col-6 f14-400 ">
            2887 Maple Street
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-6 f14-700 ">Address Line 2</div>
            <div className="col-6 f14-400 ">
            2887 Maple Street
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-6 f14-700 ">State</div>
            <div className="col-6 f14-400 ">
            Maharashtra
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-6 f14-700 ">City</div>
            <div className="col-6 f14-400 ">
            Pune
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-6 f14-700 ">Country</div>
            <div className="col-6 f14-400 ">
            India
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-6 f14-700 ">Zipcode</div>
            <div className="col-6 f14-400 ">
            411002
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-6 f14-700 ">Alternate Phone Number</div>
            <div className="col-6 f14-400 ">
            +91 9876543210
            </div>
          </div>
          <hr />
          <div className="row mt-2">
            <div className="col-3 f14-700 ">Select Status</div>
          </div>
          <div className="row mt-2">
            <div className="col-3 f14-400 ">Select Status</div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

const FlagModal = (props) => {
  const [showBlockUser, seShowBlockUser] = useState(false);
  const handleCloseBlockUser = () => seShowBlockUser(false);
  const handleShowBlockUser = () => seShowBlockUser(true);
  return (
    <React.Fragment>
      {props.mobileView ? (
        <button
          type="button"
          className="n_button_d_status font_18_m "
          style={{ backgroundColor: "#9E9E9E", color: "white" }}
          onClick={handleShowBlockUser}
        >
          Flag
        </button>
      ) : (
        <Fragment>
          {props.redButton ? (
            <div className="enIconBtn mr-1" onClick={handleShowBlockUser}>
              <Image
                src={require("../../../assets/images/UserManagement/flag.svg")}
                alt="Delete"
                title="Delete"
                fluid
              />
            </div>
          ) : (
            <button
              type="button"
              className="enBtnoutlineGrayIcon"
              onClick={handleShowBlockUser}
            >
              <SVG
                src={require("../../../assets/images/UserManagement/flag.svg")}
              />
            </button>
          )}
        </Fragment>
      )}

      <Modal show={showBlockUser} onHide={handleCloseBlockUser} centered>
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <Modal.Title>Flag Staff</Modal.Title>
        </Modal.Header>
        <Modal.Body className="f16-500">
          Are you sure to Flag the staff?
        </Modal.Body>
        <Modal.Footer className="justify-content-start border-0">
          <Button
            variant="outline-secondary"
            className="btn-lg mr-4 px-5"
            onClick={handleCloseBlockUser}
          >
            No
          </Button>
          <Button
            variant="danger"
            className="btn-lg px-5"
            onClick={() => {
              handleCloseBlockUser();
              props.onClick(handleCloseBlockUser);
            }}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default MobileStaffManagement;
